import {RestResource} from '../rest'
import {EQUIPMENT_IN_OUT_SERVER} from "@/api";

const signRecord = new RestResource({server: EQUIPMENT_IN_OUT_SERVER, resource: 'signRecord'});

export default signRecord;